import React, { useState, useEffect } from 'react';
import {
  Typography,
  Button,
  Modal,
  Backdrop,
  Fade,
  Box,
  makeStyles,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import fontFamily from '../../../../assets/css/fonts';
import color from '../../../../assets/css/colors';
import TextField from '../../../../components/Textfields/TextField';
import SelectSystemCode from '../../../../components/Dropdown/SelectSystemCode';
import { notifySuccess, notifyError } from '../../../../components/Messages/Notification';
import {
  createAccount,
  readDefaultGlBank,
  updateAccount,
} from '../../../../services/BankAccountService';
import { listBankAddress } from '../../../../services/BankAddressService';
import { readPrimaryOwner } from '../../../../services/CommonService';
import AutoCompleteCorrespondent from '../../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountNo from '../../../../components/AutoComplete/AutoCompleteAccountNo';
import { getCurrentUser } from '../../../../services/AuthService';
import {
  getAccountInfo,
  getAccessibleClient,
} from '../../../../services/ClientAccountService';
import { usePlaidLink } from 'react-plaid-link';
import { ExchangePublicToken, GetAuth } from '../../../../services/PlaidService';
import Text from '../../../../components/Typography/Text';
import { sendErrorMsg } from '../../../../services/ErrorMsgService';
import SelectBankName from '../../../../components/Dropdown/SelectBankName';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 850,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: '30px 0px 0px 30px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& > div:nth-child(1)': {
      flex: 'none',
      marginRight: 7,
      '& > svg': {
        width: 28,
        height: 28,
        '& path': {},
      },
    },
    '& div:nth-child(2)': {
      flex: 1,
    },
    '& div:nth-child(3)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {},
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 30px',
    maxHeight: 600,
    overflowY: 'auto',
    fontFamily: fontFamily.headers,
    color: color.default.main,
    '& p': {
      fontSize: 16,
      fontFamily: fontFamily.headers,
      fontWeight: 400,
      lineHeight: '26px',
      color: color.default.main,
      marginTop: 0,
    },
    '& hr': {
      margin: '30px 0px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 120,
    },
  },
  incompleteSteps: {
    fontSize: 16,
    lineHeight: '24px',
    marginTop: 20,
    '& > label': {
      fontWeight: 600,
      marginBottom: 10,
      display: 'block',
    },
    '& ul': {
      listStyle: 'none',
      margin: '0px 0px 0px -40px',
      lineHeight: '30px',
      '& > li > span': {
        position: 'relative',
        top: 4,
        '& > svg': {
          width: 20,
          height: 20,
        },
      },
    },
  },
  success: {
    '& > svg > path': {},
  },
  error: {
    '& > svg > path': {},
  },
  closeButton: {
    '& button': {
      marginTop: '-5px !important',
    },
  },
}));

let tempFixData = {};
export default function ManualInputModal({ onClose, iopen, value }) {
  const classes = useStyles();
  const [rowData] = React.useState({
    token: value?.linktoken?.linkToken,
  });

  const [mOpen, setMOpen] = React.useState(iopen);
  let notifications = [];
  const [loading, setLoading] = React.useState(false);
  const [enablePAT, setEnablePAT] = React.useState(false);
  const [disableRequestType, setDisableRequestType] = React.useState({
    ach: false,
    wire: false,
  });

  const [plaidData, setPlaidData] = React.useState({});
  const [origPlaidDataACH, setOrigPlaidDataACH] = React.useState({});
  const [accessToken, setAccessToken] = React.useState({});
  const [metaData, setMetadata] = React.useState(null);
  const [modalData, setModalData] = useState(
    value || {
      bankAccountType: '',
      bankAddressId: 0,
      status: '',
      bankId: 0,
      glAccountId: 0,
      bankOwnerName: '',
      bankName: '',
      bankAccountNo: '',
      correspondent: '',
      accountNo: '',
      achRoutingNo: '',
      wireRoutingNo: '',
      plaidAccessToken: '',
      isInternational: false,
      bankIdentifierCode: '',
      approvedMethod: '',
      nickName: '',
      ach: false,
      wire: false,
      check: false,
    }
  );

  const setTempFixData = (data) => {
    tempFixData = data;
    setModalData(data);
  };

  const [bankAddressIdPromiseTimeout] = useState(0);
  const [bankOwnerNamePromiseTimeout, setBankOwnerNamePromiseTimeout] = useState(0);
  const isEnabled = !value || !value.bankId || value.status === 'Pending Approval';
  const isApprovedMethodEnabled =
    modalData.correspondent !== '' && modalData.accountNo !== '';

  const setBankOwnerName = async (param) => {
    try {
      if (!param.correspondent || !param.accountNo) {
        return '';
      }

      const { fullName } = await readPrimaryOwner({
        correspondent: param.correspondent,
        accountNo: param.accountNo,
      });
      if (fullName) {
        setTempFixData({ ...modalData, bankOwnerName: fullName });
      }
    } catch (err) {
      if (err.message !== `-2:database error, 'read primary owner' record not found;`)
        notifyError(err.message);
    }

    return '';
  };

  useEffect(() => {
    if (iopen) {
      const initAccess = async () => {
        let account_no = '';
        let correspondent = '';

        const loggeduser = getCurrentUser();
        if (loggeduser === null) return;
        try {
          if (loggeduser.AccountId !== 0) {
            const account = await getAccountInfo();
            account_no = account.accountNo;
            correspondent = account.correspondent;
          } else {
            const account = await getAccessibleClient(loggeduser.UserId);
            account_no = account.client.accountNo;
            correspondent = account.client.correspondent;
          }
          if (value) {
            setTempFixData({
              ...value,
              accountNo: account_no,
              correspondent: correspondent,
            });
          } else {
            setTempFixData({
              ...modalData,
              accountNo: account_no,
              correspondent: correspondent,
            });
          }
        } catch (error) {
          notifyError(error.message);
          console.error(error);
        }
      };

      initAccess();

      if (!modalData.glAccountId) {
        const init = async () => {
          try {
            const data = await readDefaultGlBank();
            if (value) {
              setTempFixData({
                ...value,
                glAccountId: data.accountId,
              });
            } else {
              setTempFixData({
                ...modalData,
                glAccountId: data.accountId,
              });
            }
          } catch (error) {
            notifyError(error.message);
            console.error(error);
          }
          //await loadData("Micro Deposit")
        };

        init();
      }
    }
    // eslint-disable-next-line
  }, [iopen]);

  useEffect(() => {
    if (bankOwnerNamePromiseTimeout) clearTimeout(bankOwnerNamePromiseTimeout);
    if (bankAddressIdPromiseTimeout) clearTimeout(bankAddressIdPromiseTimeout);

    setBankOwnerNamePromiseTimeout(
      setTimeout(() => {
        setBankOwnerName(modalData);
      }, 1000)
    );

    return () => {
      if (bankOwnerNamePromiseTimeout) clearTimeout(bankOwnerNamePromiseTimeout);
    };
    // eslint-disable-next-line
  }, [modalData.correspondent, modalData.accountNo, modalData.correspondent]);

  const handleChangePlaidDataACH = (e, index) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;
    const { name, value } = input;

    setPlaidData((current) => {
      const newNumbers = [...current.numbers.ach];
      newNumbers[index] = {
        ...newNumbers[index],
        [name]: value,
      };

      return {
        ...current,
        numbers: {
          ...current.numbers,
          ach: newNumbers,
        },
      };
    });
  };

  const handleChange = async (e, checkboxValue) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;
    const modalDataCopy = { ...modalData };
    modalDataCopy[input.name] =
      checkboxValue === true || checkboxValue === false ? checkboxValue : input.value;

    if (['bankName', 'achRoutingNo', 'wireRoutingNo'].includes(input.name)) {
      if (typeof modalDataCopy.bankName === 'object') {
        modalDataCopy.bankAddressId = '';
        modalDataCopy.achRoutingNo = modalDataCopy.bankName.bankRoutingNo;
        modalDataCopy.bankName = modalDataCopy.bankName.bankName;
      }
    }

    setTempFixData(modalDataCopy);

    if (
      input.name === 'approvedMethod' &&
      (input.value === 'Plaid' || input.value === 'Micro Deposit')
    ) {
      setMOpen(false);
      open();
    }
  };

  const config = {
    onSuccess: async (public_token, metadata) => {
      var at;
      var auth_data;
      try {
        const actok = await ExchangePublicToken({
          public_token: public_token,
        });
        if (actok.errorCode !== '') {
          notifyError(actok.errorCode + ' ' + actok.errorMessage);
          console.error(actok);
          return;
        }
        at = actok;
      } catch (e) {
        notifyError(e);
        console.error(e);
        return;
      }

      let modalDataCopy = { ...tempFixData, bankName: metadata?.institution?.name || '' };

      try {
        const ad = await GetAuth({
          access_token: at.accessToken,
        });

        auth_data = ad;
      } catch (e) {
        notifyError(e);
        console.error(e);
        return;
      }
      const dataresp = JSON.parse(auth_data.json);
      if (dataresp.error_code && dataresp.error_code === 'PRODUCT_NOT_READY') {
        //micro deposit
        modalDataCopy = {
          ...modalDataCopy,
          plaidAccessToken: at.accessToken,
          status: 'Pending Verification',
        };
        setEnablePAT(true);
        setTempFixData(modalDataCopy);
        setDisableRequestType({
          ...disableRequestType,
          ach: false,
          wire: false,
        });
      } else {
        const plaid_bank_data = dataresp.numbers.ach;
        if (dataresp.error_code && dataresp.error_code !== '') {
          notifyError(dataresp.errorCode + ' ' + dataresp.errorMessage);
          console.error(dataresp);
          return;
        }
        modalDataCopy = {
          ...modalDataCopy,
          plaidAccessToken: at.accessToken,
          status: plaid_bank_data[0]?.verification_status
            ? 'Pending Verification'
            : 'Active',
        };
        setEnablePAT(true);

        if (at.accessToken !== '' && modalDataCopy.approvedMethod === 'Micro Deposit') {
          modalDataCopy.ach = true;
          modalDataCopy.wire = true;
          setDisableRequestType({ ...disableRequestType, ach: true });
        }
        if (at.accessToken !== '' && modalDataCopy.approvedMethod === 'Plaid') {
          if (plaid_bank_data[0].wire_routing !== '') {
            modalDataCopy.ach = true;
            modalDataCopy.wire = true;
            setDisableRequestType({
              ...disableRequestType,
              ach: true,
            });
          } else {
            modalDataCopy.ach = true;
            modalDataCopy.wire = false;
            setDisableRequestType({
              ...disableRequestType,
              ach: true,
            });
          }
        }
        setTempFixData(modalDataCopy);
      }

      exit();
      setMOpen(true);
      if (dataresp.numbers?.ach) {
        setOrigPlaidDataACH(dataresp.numbers?.ach);
      }
      setPlaidData(dataresp);
      setAccessToken(at);

      setMetadata(metadata);
    },
    onExit: (err, metadata) => {
      if (err) {
        const errorMsg = JSON.stringify(err, null, 2);

        let errorMessage = '';
        if (err?.error_code === 'INTERNAL_SERVER_ERROR') {
          const institutionName = metadata?.institution?.name;
          errorMessage =
            'Plaid error: ' +
            err.error_message +
            ' when using ' +
            institutionName +
            ' institution.';
          notifyError(errorMessage);
        } else {
          errorMessage = 'Plaid error: ' + errorMsg;
          notifyError(errorMessage);
        }
        sendErrorMsg({
          errorMsg: errorMessage,
          setType: 'Plaid',
          criticalLevel: 1,
        });
      }

      setTempFixData({ ...tempFixData, approvedMethod: '' });
      exit();
      setMOpen(true);
    },
    onEvent: (eventName, metadata) => {},
    token: rowData.token ? rowData.token : '',
    env: window.env.PLAID_ENVIRONMENT ? window.env.PLAID_ENVIRONMENT : 'sandbox',
    receivedRedirectUri: null,
  };

  const { open, exit } = usePlaidLink(config);

  function typeMap(status) {
    var text;
    switch (status) {
      case 'checking':
        text = 'Checking';
        break;
      case 'savings':
        text = 'Savings';
        break;
      case 'cash management':
        text = 'Cash Management';
        break;

      default:
        text = '';
    }
    return text;
  }

  function getType(account_id, ar_account) {
    var type = '';

    ar_account.forEach(function (data) {
      if (account_id === data.account_id) type = data.subtype;
    });
    return type;
  }

  function getName(account_id, ar_account) {
    var type = '';

    ar_account.forEach(function (data) {
      if (account_id === data.account_id) type = data.name;
    });
    return type;
  }

  const saveData = async (data, plaidData, accessToken, metaData) => {
    if (!data.accountNo) {
      return notifyError('Account No is required.');
    }
    if (!data.correspondent) {
      return notifyError('Correspondent is required.');
    }

    if (!data.approvedMethod || data.approvedMethod === 'N/A') {
      return notifyError('Approved Method is required.');
    }
    if (!data.plaidAccessToken && data.approvedMethod === 'Plaid') {
      return notifyError('Plaid Access Token is required.');
    }

    if (data.isInternational === true && data.bankIdentifierCode === '') {
      return notifyError('Bank Identifier Code (BIC) is required.');
    }

    if (!data.ach && !data.wire && !data.check) {
      return notifyError('Allowed Request is required.');
    }

    if (typeof data.bankAddressId === 'object') {
      data.bankAddressId = data.bankAddressId.bankAddressId;
    }

    if (data.isInternational === false) {
      data.bankIdentifierCode = '';
    }

    try {
      if (data.bankId) {
        const { bankAccount } = await updateAccount(data);
        notifySuccess('Bank Account has been updated.');
        onClose(bankAccount, true);
      } else {
        //Via Plaid
        if (data.approvedMethod === 'Plaid') {
          if (!plaidData.numbers) {
            return notifyError('PLAID data is not fetched.');
          }
        }
        var bankAccounts = [];

        const plaid_bank_data = plaidData.numbers.ach;

        for (const pdata of plaid_bank_data) {
          var address_id = 0;
          try {
            const address = await listBankAddress({
              bank_routing_no: data.routing,
            });
            address_id = address.bank_addresses[0].bank_address_id;
          } catch (error) {
            address_id = 0;
          }
          try {
            const param = {
              correspondent: data.correspondent,
              accountNo: data.accountNo,
              bankAccountNo: pdata.account,
              plaidAccessToken: accessToken.accessToken,
              bankName: data.bankName,
              bankAddressId: address_id,
              bankAccountType: typeMap(getType(pdata.account_id, plaidData.accounts)),
              bankOwnerName: getName(pdata.account_id, plaidData.accounts),
              achRoutingNo: pdata.routing,
              wireRoutingNo: pdata.wire_routing,
              approvedMethod: data.approvedMethod,
              status: 'Active',
              nickName: data.nickName,
              ach: data.ach,
              wire: data.wire,
              check: data.check,
            };
            const res = await createAccount(param);
            bankAccounts.push(res.bankAccount);
            const newNotification = {
              type: 'success',
              message: `${param.bankAccountNo} bank account has been saved`,
            };
            const updatedPlaidData = plaidData.numbers.ach?.filter(
              (plaiddata) => plaiddata.account !== pdata.account
            );
            setPlaidData({
              ...plaidData,
              numbers: { ...plaidData.numbers, ach: updatedPlaidData },
            });
            notifications.push(newNotification);
          } catch (error) {
            console.error(error);
            const newNotification = {
              type: 'error',
              message: 'Error:' + error.message,
            };
            notifications.push(newNotification);
          }
        }
        if (notifications.length > 0) {
          notifications.forEach((notif) => {
            notif.type === 'success'
              ? notifySuccess(notif.message)
              : notifyError(notif.message);
          });
        }
        const hasError = notifications.some(
          (notification) =>
            notification.type === 'error' &&
            !notification.message.includes('already exist')
        );

        if (hasError) {
          return;
        }
        onClose(bankAccounts);
      }
    } catch (error) {
      console.error(error);
      return notifyError('Error:' + error.message);
    }
  };

  const handleSave = async () => {
    setLoading(true);

    let valid = true;

    if (plaidData.numbers?.ach) {
      plaidData.numbers?.ach.forEach((ach) => {
        if (!ach.wire_routing && modalData.wire) {
          notifyError(`${ach.account} Wire Routing No is required.`);
          valid = false;
        }
        if (!ach.routing && modalData.ach) {
          notifyError(`${ach.account} ACH Routing No is required.`);
          valid = false;
        }
      });
    }
    if (valid) {
      await saveData(modalData, plaidData, accessToken, metaData);
    }
    setLoading(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={mOpen}
      onClose={() => onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={mOpen}>
        <div style={{ width: 2000 }}>
          <Box mt={5}></Box>
          <form noValidate autoComplete="off">
            <input type="hidden" autoComplete="off" />
            <div className={classes.modalHeader}>
              <Typography
                id="transition-modal-title"
                variant="h2"
                className={classes.textBold}
                gutterBottom
              >
                {modalData.bankId ? 'Edit' : 'Add New'} Bank Account
              </Typography>
            </div>
            <div className={classes.modalBody}>
              <div>
                <div className="grd-row">
                  <div className="grd-cell">
                    <AutoCompleteCorrespondent
                      required={true}
                      disabled={!isEnabled}
                      isActive
                      name="correspondent"
                      value={modalData.correspondent || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="grd-cell">
                    <AutoCompleteAccountNo
                      required={true}
                      isActive
                      disabled={!isEnabled}
                      name="accountNo"
                      value={modalData.accountNo || ''}
                      correspondent={modalData.correspondent}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="grd-cell">
                    <TextField
                      name="nickName"
                      label="Nick Name"
                      placeholder="Nick Name"
                      type="text"
                      value={modalData.nickName}
                      onChange={handleChange}
                      inputProps={{ maxLength: 20 }}
                    />
                  </div>
                </div>
              </div>

              <div className="grd-row">
                <div>
                  <Text variant="p" required label="Allowed Request" />
                </div>
              </div>

              <div className="grd-row" style={{ marginTop: 0 }}>
                <div className="grd-cell" style={{ marginRight: 20 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="ach"
                        disabled={disableRequestType.ach}
                        checked={modalData.ach || false}
                        onChange={handleChange}
                      />
                    }
                    label="ACH"
                  />
                </div>
                <div className="grd-cell" style={{ marginRight: 20 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="wire"
                        disabled={disableRequestType.wire}
                        checked={modalData.wire || false}
                        onChange={handleChange}
                      />
                    }
                    label="Wire"
                  />
                </div>
                <div className="grd-cell" style={{ marginRight: 20 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="check"
                        checked={modalData.check || false}
                        onChange={handleChange}
                      />
                    }
                    label="Check"
                  />
                </div>
              </div>

              <div>
                {plaidData.numbers?.ach.map((ach, index) => {
                  return (
                    <div className="grd-row">
                      {modalData.ach && (
                        <div className="grd-cell">
                          <TextField
                            required={true}
                            max={9}
                            disabled={!!origPlaidDataACH[index].routing}
                            name="routing"
                            label={`${ach.account} ACH Routing No`}
                            type="text"
                            value={plaidData.numbers?.ach[index].routing}
                            onChange={(e) => handleChangePlaidDataACH(e, index)}
                          />
                        </div>
                      )}
                      {modalData.wire && (
                        <div className="grd-cell">
                          <TextField
                            required={true}
                            max={9}
                            disabled={!!origPlaidDataACH[index].wire_routing}
                            name="wire_routing"
                            label={`${ach.account} Wire Routing No`}
                            type="text"
                            value={plaidData.numbers?.ach[index].wire_routing}
                            onChange={(e) => handleChangePlaidDataACH(e, index)}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {isEnabled && metaData && (
                <div className="grd-row">
                  <div className="grd-cell">
                    <SelectBankName
                      freeSolo={!!metaData?.institution?.name}
                      required={true}
                      disabled={!isEnabled || metaData?.institution?.name}
                      name="bankName"
                      label="Bank Name"
                      value={modalData.bankName}
                      onChange={handleChange}
                    ></SelectBankName>
                  </div>
                </div>
              )}
              {isEnabled && enablePAT && (
                <div className="grd-row">
                  <div className="grd-cell">
                    <TextField
                      required={modalData.approvedMethod === 'Plaid'}
                      name="plaidAccessToken"
                      label="Plaid Access Token"
                      placeholder="Plaid Access Token"
                      type="text"
                      value={modalData.plaidAccessToken}
                      onChange={handleChange}
                      inputProps={{ maxLength: 60 }}
                      disabled={!isEnabled || !enablePAT}
                    />
                  </div>
                </div>
              )}
              {isEnabled && modalData.isInternational && (
                <div className="grd-row">
                  <div className="grd-cell">
                    <TextField
                      required={modalData.isInternational}
                      name="bankIdentifierCode"
                      label="Bank Identifier Code (BIC)"
                      placeholder="Bank Identifier Code (BIC)"
                      type="text"
                      value={modalData.bankIdentifierCode}
                      onChange={handleChange}
                      inputProps={{ maxLength: 30 }}
                      disabled={!isEnabled || !modalData.isInternational}
                    />
                  </div>
                </div>
              )}
              <div className="grd-row">
                <div className="grd-cell">
                  <SelectSystemCode
                    required={true}
                    name="approvedMethod"
                    label="Approved Method"
                    placeholder="Approved Method"
                    type="Approved Method"
                    value={modalData.approvedMethod || ''}
                    onChange={handleChange}
                    disabled={!isEnabled || !isApprovedMethodEnabled}
                    disabledItem={{
                      'N/A': true,
                    }}
                    addItemMenuTooltip
                  />
                </div>
              </div>
            </div>
            <div className={classes.modalFooter}>
              <div className="grd-row">
                <div className="grd-cell" style={{ marginRight: 10 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => onClose()}
                  >
                    Close
                  </Button>
                </div>
                <div className="grd-cell">
                  <Button
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </div>
                <div className="grd-cell"></div>
              </div>
            </div>
          </form>
        </div>
      </Fade>
    </Modal>
  );
}
